module.exports = __webpack_public_path__ + "static/img/fxng1.b3fc617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fxng1.png
// module id = POhS
// module chunks = 4